import React, { useState, useEffect } from 'react';
import { useControleDemanda } from '../context/ControleDemandaProvider';
import { useAuth } from '../../shared/context/AuthContext';

export default function ModalResposta({ demanda, onClose, onSuccess }) {
  const { responderDemanda } = useControleDemanda();
  const { user } = useAuth();
  const [resposta, setResposta] = useState('');
  const [loading, setLoading] = useState(false);

  // Carregar resposta atual se existir
  useEffect(() => {
    if (demanda.resposta) {
      setResposta(demanda.resposta);
    }
  }, [demanda.resposta]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!resposta.trim()) {
      alert('Por favor, digite uma resposta.');
      return;
    }

    setLoading(true);
    try {
      await responderDemanda(demanda.id, resposta.trim(), user.id);
      onSuccess();
    } catch (error) {
      console.error('Erro ao responder demanda:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-resposta">
        <div className="modal-header">
          <h3>{demanda.resposta ? 'Editar Resposta' : 'Responder Demanda'}</h3>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <div className="demanda-info">
            <h4>Demanda #{demanda.protocolo || demanda.id}</h4>
            <p><strong>Descrição:</strong> {demanda.descricao}</p>
            <p><strong>Categoria:</strong> {demanda.categoria?.nome || 'N/A'}</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="resposta">
                {demanda.resposta ? 'Editar Resposta *' : 'Resposta *'}
              </label>
              {demanda.resposta && (
                <small className="form-text text-info" style={{ marginBottom: '8px', display: 'block' }}>
                  <i className="fas fa-info-circle"></i> Você está editando uma resposta existente
                </small>
              )}
              <textarea
                id="resposta"
                value={resposta}
                onChange={(e) => setResposta(e.target.value)}
                className="form-control"
                rows="6"
                placeholder="Digite sua resposta para o solicitante..."
                required
              />
              <small className="form-text">
                Esta resposta será enviada para o solicitante da demanda.
              </small>
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !resposta.trim()}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    {demanda.resposta ? 'Atualizando...' : 'Enviando...'}
                  </>
                ) : (
                  <>
                    <i className={demanda.resposta ? 'fas fa-edit' : 'fas fa-reply'}></i>
                    {demanda.resposta ? 'Atualizar Resposta' : 'Enviar Resposta'}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}